import axios from 'axios';

// interface
import {
  FetchBrand,
  CreateBrand,
  UpdateBrand,
  ListRoleinBrand,
  CreateRoleInBrand,
  UpdateRoleInBrand,
  DeleteRolesInBrand,
  ManageUserInBrand,
  DeleteUserInBrand,
  FetchBrandWithId,
  FetchRoleBrandWithId,
  UploadBrandPicture,
} from '@app/typings/services/brand.d';
import { endpoint, headers } from '@app/utils/service';

export const fetchBranch: FetchBrand = (name) => {
  return axios({
    url: endpoint(`/brands`),
    method: 'GET',
    params: {
      name: name,
      limit: 0,
    },
    ...headers(),
  });
};

export const fetchBrandWithId: FetchBrandWithId = (brandId) => {
  return axios({
    url: endpoint(`/brands/${brandId}`),
    method: 'GET',
    ...headers(),
  });
};

export const createBrand: CreateBrand = (data) => {
  return axios({
    url: endpoint('/brands'),
    method: 'POST',
    ...headers(),
    data: {
      name: data.brandName,
      addresses: {
        name: data.bussinessName,
        type: 'primary',
        line1: data.line1,
        line2: data.line2,
        province: data.province,
        district: data.district,
        subdistrict: data.subdistrict,
        postalCode: data.postalCode,
        telephone1: data.officeNumber,
      },
      contact: {
        phone: data.phoneNumber,
        fax: data.faxNumber,
      },
      taxId: data.taxNumber,
      businessType: data.bussinessType,
      vatStatus: data.VATRegis,
      branchCode: data.branchCode,
    },
  });
};

export const updateBrand: UpdateBrand = (id, data, isSameName) => {
  if (isSameName) {
    return axios({
      url: endpoint(`/brands/${id}`),
      method: 'PATCH',
      ...headers(),
      data: {
        addresses: {
          type: 'primary',
          name: data.bussinessName,
          line1: data.line1,
          line2: data.line2,
          province: data.province,
          district: data.district,
          subdistrict: data.subdistrict,
          postalCode: data.postalCode,
          telephone1: data.officeNumber,
        },
        contact: {
          phone: data.phoneNumber,
          fax: data.faxNumber,
        },
        taxId: data.taxNumber,
        businessType: data.bussinessType,
        vatStatus: data.VATRegis,
        branchCode: data.branchCode,
      },
    });
  } else {
    return axios({
      url: endpoint(`/brands/${id}`),
      method: 'PATCH',
      ...headers(),
      data: {
        name: data.brandName,
        addresses: {
          type: 'primary',
          name: data.bussinessName,
          line1: data.line1,
          line2: data.line2,
          province: data.province,
          district: data.district,
          subdistrict: data.subdistrict,
          postalCode: data.postalCode,
          telephone1: data.officeNumber,
        },
        contact: {
          phone: data.phoneNumber,
          fax: data.faxNumber,
        },
        taxId: data.taxNumber,
        businessType: data.bussinessType,
        vatStatus: data.VATRegis,
        branchCode: data.branchCode,
      },
    });
  }
};

export const listRoleInBrand: ListRoleinBrand = (brandId, offset, limit) => {
  return axios({
    url: endpoint(`/brands/${brandId}/roles`),
    method: 'GET',
    params: {
      offset: offset,
      limit: limit,
    },
    ...headers(),
  });
};

export const listRoleInBrandAdmin: ListRoleinBrand = (brandId, offset, limit) => {
  return axios({
    url: endpoint(`/brands/${brandId}/users`),
    method: 'GET',
    params: {
      offset: offset,
      limit: limit,
    },
    ...headers(),
  });
};

export const createRoleInBrand: CreateRoleInBrand = (brandId, roleName, permission) => {
  const statementData = permission.map((item: string) => ({
    permission: item,
    resources: ['*'],
  }));

  return axios({
    url: endpoint(`/brands/${brandId}/roles`),
    method: 'POST',
    ...headers(),
    data: {
      name: roleName,
      statements: statementData,
    },
  });
};

export const updateRoleInBrand: UpdateRoleInBrand = (brandId, roleId, roleName, permission) => {
  const statementData = permission.map((item: string) => ({
    permission: item,
    resources: ['*'],
  }));

  return axios({
    url: endpoint(`/brands/${brandId}/roles/${roleId}`),
    method: 'PATCH',
    ...headers(),
    data: {
      name: roleName || undefined,
      statements: statementData,
    },
  });
};

export const deleteRolesInBrand: DeleteRolesInBrand = (brandId, roleId) => {
  return axios({
    url: endpoint(`/brands/${brandId}/roles/${roleId}`),
    method: 'DELETE',
    ...headers(),
  });
};

export const manageUsersInBrand: ManageUserInBrand = (brandId, userId, roleId) => {
  return axios({
    url: endpoint(`/brands/${brandId}/users`),
    method: 'PUT',
    ...headers(),
    data: {
      userId: userId,
      roleId: roleId,
    },
  });
};

export const deleteUsersInBrand: DeleteUserInBrand = (brandId, userId) => {
  return axios({
    url: endpoint(`/brands/${brandId}/users`),
    method: 'PUT',
    ...headers(),
    data: {
      userId: userId,
    },
  });
};

export const fetchRoleInBrandWithId: FetchRoleBrandWithId = (brandId, roleId) => {
  return axios({
    url: endpoint(`/brands/${brandId}/roles/${roleId}`),
    method: 'GET',
    ...headers(),
  });
};

export const uploadBrandPicture: UploadBrandPicture = (brandId, file) => {
  const formData = new FormData();
  formData.append('file', file);

  return axios({
    url: endpoint(`/brands/${brandId}/upload`),
    method: 'POST',
    data: formData,
    ...headers({ 'Content-Type': 'multipart/form-data' }),
  });
};
